import React from "react"

function Laptop({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.3333 23H19.6667M14 10.5H22C22.9334 10.5 23.4002 10.5 23.7567 10.6817C24.0703 10.8414 24.3253 11.0964 24.485 11.41C24.6667 11.7665 24.6667 12.2332 24.6667 13.1667V17.8333C24.6667 18.7667 24.6667 19.2335 24.485 19.59C24.3253 19.9036 24.0703 20.1586 23.7567 20.3183C23.4002 20.5 22.9334 20.5 22 20.5H14C13.0666 20.5 12.5999 20.5 12.2434 20.3183C11.9298 20.1586 11.6748 19.9036 11.515 19.59C11.3334 19.2335 11.3334 18.7667 11.3334 17.8333V13.1667C11.3334 12.2332 11.3334 11.7665 11.515 11.41C11.6748 11.0964 11.9298 10.8414 12.2434 10.6817C12.5999 10.5 13.0666 10.5 14 10.5ZM11.8241 25.5H24.176C24.8903 25.5 25.2475 25.5 25.4626 25.3496C25.6504 25.2182 25.7759 25.0152 25.8094 24.7885C25.8478 24.5287 25.688 24.2093 25.3686 23.5704L24.9389 22.7112C24.5376 21.9085 24.3369 21.5072 24.0376 21.2139C23.7728 20.9547 23.4538 20.7575 23.1034 20.6367C22.7073 20.5 22.2586 20.5 21.3613 20.5H14.6388C13.7414 20.5 13.2927 20.5 12.8966 20.6367C12.5463 20.7575 12.2272 20.9547 11.9625 21.2139C11.6631 21.5072 11.4624 21.9085 11.0611 22.7112L10.6315 23.5704C10.312 24.2093 10.1523 24.5287 10.1907 24.7885C10.2242 25.0152 10.3496 25.2182 10.5374 25.3496C10.7526 25.5 11.1097 25.5 11.8241 25.5Z"
        stroke="#003E4C"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
export default Laptop
